<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum doručení</label>
    <div class="input"><input type="text" pick-a-date [ngModel]="data.receivedOwnerDate" (ngModelChange)="onReceiveDateUpdate($event)" [maxToday]="true"/></div>
  </div>
</fieldset>
